import { RuleRunCriteriaField } from "@rebuild/shared";
import { InputFieldProps } from "./types";
import { GenericRuleRunCriteriaInput } from "../GenericInputComponents";
import { useTpas } from "../../../hooks/useTpas";

export const TpaInput: React.FC<InputFieldProps> = ({ inputField, inputValue, onUpdate: _onUpdate }) => {
	if (inputField.type !== "tpas") {
		return <>non-tpa types are currently not supported</>;
	}

	const tpaCriteriaList = inputValue as RuleRunCriteriaField | undefined;

	const { tpas } = useTpas();

	return (
		<GenericRuleRunCriteriaInput
			ruleRunCriteriaList={tpaCriteriaList}
			options={tpas}
			getDisplayValue={(tpa) => tpa.name}
			getObjId={(tpa) => tpa.id}
			onUpdate={(newValue) => _onUpdate?.(newValue)}
		/>
	);
};
